import { ChangeDetectionStrategy, Component } from '@angular/core';

import { HistoryState } from './history-routing.module';

@Component({
  selector: 'cng-history',
  templateUrl: 'history.component.html',
  styleUrls: ['./history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HistoryComponent {
  readonly HistoryState = HistoryState;
}
